import {
  MainImage,
  VideoWrapper,
} from '@/themes/globalStyles';

interface MainMediaTypeProps {
  vimeoCode: string;
  youtubeId: string | false;
  mainImage: string;
}

export const MainMedia = ({
  vimeoCode,
  youtubeId,
  mainImage,
}: MainMediaTypeProps) => {
  if (vimeoCode) {
    return (
      <VideoWrapper
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: vimeoCode,
        }}
      />
    );
  }

  if (youtubeId) {
    return (
      <VideoWrapper>
        <iframe
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          frameBorder="0"
          src={`https://www.youtube.com/embed/${youtubeId}`}
          title={youtubeId}
        />
      </VideoWrapper>
    );
  }

  if (mainImage) {
    return (
      <MainImage
        alt="Take action"
        src={mainImage}
      />
    );
  }

  return null;
};
